import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=25a8afa9&scoped=true&"
var script = {}
import style0 from "./TabBar.vue?vue&type=style&index=0&id=25a8afa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8afa9",
  null
  
)

export default component.exports